// @flow
import api from 'tim-api';
import { distributors } from 'endPoints';

const deParaChip = 'sigtim/distributors-from-to-simcard';

export const state = {
  deParaChip: [],
  distributors: [],
  distributorsPara: [],
  distributorRelation: []
};

export const getters = {
  deParaChipList: (state: Object) => state.deParaChip,
  distributors: (state: Object) => state.distributors,
  distributorsPara: (state: Object) => state.distributorsPara,
  distributorRelation: (state: Object) => state.distributorRelation
};

export const mutations = {
  DE_PARA_CHIP(state: Object, payload: Array<Object>) {
    state.deParaChip = payload;
  },
  DISTRIBUTORS(state: Object, payload: Array<Object>) {
    state.distributors = payload;
  },
  DISTRIBUTORSPARA(state: Object, payload: Array<Object>) {
    state.distributorsPara = payload;
  },
  SET_DISTRIBUTOR_RELATION(state: Object, payload: Array<Object>) {
    state.distributorRelation = payload;
  }
};

export const actions = {
  fetchDePara({ commit }: Action, payload: Object) {
    return api.get(deParaChip, payload)
      .then(({ data }) => {
        commit('DE_PARA_CHIP', data.data);
      });
  },
  fetchDeParaFiltro({ commit }: Action, payload: Object) {
    return api.post(`${deParaChip}/filter`, payload)
      .then(({ data }) => {
        commit('DE_PARA_CHIP', data.data);
      });
  },
  fetchDistributors({ commit }: Action) {
    return api.get(`${distributors}/all?sort=name&order=asc`)
      .then(({ data }) => {
        commit('DISTRIBUTORS', data);
      });
  },
  fetchDistributorsPara({ commit }: Action, id: string) {
    return api.get(`${deParaChip}/all/${id}`)
      .then(({ data }) => {
        commit('DISTRIBUTORSPARA', data);
      });
  },
  // eslint-disable-next-line
  fetchDistributorRelation({ commit }: Action, id: string) {
    return api.get(`${deParaChip}/${id}`)
      .then(({ data }) => {
        commit('SET_DISTRIBUTOR_RELATION', data.data);
      });
  },
  // eslint-disable-next-line
  save({ commit }: Action, payload: Object) {
    return api.post(deParaChip, payload);
  },
  // eslint-disable-next-line
  update({ commit }: Action, payload: Object) {
    return api.put(deParaChip, payload);
  },
  // eslint-disable-next-line
  exclude({ commit }: Action, id: string) {
    return api.delete(`${deParaChip}/${id}`);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
